import {
  formatCurrency,
  formatNumber,
  formatPercent,
  formatAbbreviated,
} from './number-formatter';

// ---------- axisLabel (abreviado) ----------

/** Spread em axisLabel para eixo monetário abreviado. Ex.: "R$ 1,5k" */
export const AXIS_LABEL_CURRENCY = {
  formatter: (value: number) => formatAbbreviated(value, { currency: true }),
};

/** Spread em axisLabel para eixo numérico abreviado. Ex.: "1,5k" */
export const AXIS_LABEL_NUMBER = {
  formatter: (value: number) => formatAbbreviated(value),
};

/** Spread em axisLabel para eixo percentual. Ex.: "12,3%" */
export const AXIS_LABEL_PERCENT = {
  formatter: (value: number) => formatPercent(value),
};

// ---------- tooltip / dataLabel (completo) ----------

/** Uso em tooltip.formatter / label. Valor monetário completo. */
export const tooltipCurrency = (v: number): string => formatCurrency(v);

/** Uso em tooltip.formatter / label. Quantidade com separador. */
export const tooltipNumber = (v: number, decimals?: number): string =>
  formatNumber(v, decimals);

/** Uso em tooltip.formatter / label. Percentual. */
export const tooltipPercent = (v: number, decimals?: number): string =>
  formatPercent(v, decimals);
